
 
import React, { useEffect } from 'react'
import Event from './eventImg/event-23-jan.webp'


const Event31 = () => {
    useEffect(() => {
        document.title = "FemTech - Collaboration & Innovation";
      }, []);
  return (
    <>
    <div className='eventheading'>

      <h1 className='text-center'>23 January 2026</h1>
        <h3 className='text-center'>FemTech - Collaboration & Innovation </h3>
</div>
   <div className='container' id='calanderevent'>
    <img src={Event} alt='FemTech - Collaboration & Innovation'/>
     <button className='mb-4'><a href='https://ishraehq.in/Admin/CalenderEventMaster/Registration_new/FlH95ftr23o=' target='_blank'>Register Now </a></button>
    </div>
    </>
  )
}

export default Event31




